/**
 * Silencia logs verbosos no bundle de produção (`npm run build`).
 * `console.error` e `console.warn` continuam ativos para erros reais.
 */
if (process.env.NODE_ENV === 'production') {
  const noop = (): void => undefined;
  console.log = noop;
  console.debug = noop;
  console.info = noop;
}

export {};
